import api from "./axios";

export const getFieldGroup = (id) => api.get(`/field-groups/${id}`);
export const updateFieldGroup = (id, payload) => api.put(`/field-groups/${id}`, payload);
export const deleteFieldGroup = (id) => api.delete(`/field-groups/${id}`);

export const listFields = (fieldGroupId, params = {}) =>
  api.get(`/field-groups/${fieldGroupId}/fields`, { params });
export const createField = (fieldGroupId, payload) =>
  api.post(`/field-groups/${fieldGroupId}/fields`, payload);
